// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__EC_dw","errorLogs":"styles_errorLogs__1KFv8"};